export default "__VITE_ASSET__DzxfgPTHZFoHEJe8Cn5N0g__";